import BossModel from "@/models/BossModel";
import User from "@/models/User/User";

export default class UserGroup extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user/group';

    /**
     *
     * @type {string}
     */
    static entity = 'userGroups';

    static SALES = 1;
    static SALES_MANAGER = 2;
    static PRODUCT = 3;
    static CFS = 4;
    static ADMINISTRATION = 5;
    static DIRECTION = 6;
    static IATA = 7;

    static fields () {
        return {
            id: this.attr(null),
            name: this.attr(''),
            created_at: this.attr(''),
            updated_at: this.attr(''),
            users: this.hasMany(User,'user_group_id')
        }
    }

    /**
     *
     * @returns {*}
     */
    static load () {
        return this.api().with('users').limit(0).filtered({is_active: true}).get(true);
    }

    Users(){
        return this.getRelated('users');
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }
}
